import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { take } from 'rxjs/operators';
import { DadosEmpresaService } from 'src/app/services/dados-empresa.service';
import { SuccessGenericoComponent } from '../../../components/success-generico/success-generico.component';
import { LoadingGenericoComponent } from '../../../components/loading-generico/loading-generico.component';
import { ConfirmaExclusaoComponent } from '../confirma-exclusao/confirma-exclusao.component';
import { ErrorGenericoComponent } from '../../../components/error-generico/error-generico.component';
import { SelectComponent } from '../../../components/select/select.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { CamelCasePipe } from '../../../pipes/camel-case.pipe';
import { CnpjPipe } from '../../../pipes/cnpj.pipe';
import { UsuarioPermissaoPipe } from '../../../pipes/usuario-permissao.pipe';

@Component({
    selector: 'app-dados-empresa-filiais',
    templateUrl: './dados-empresa-filiais.component.html',
    styleUrls: ['./dados-empresa-filiais.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SuccessGenericoComponent, LoadingGenericoComponent, ConfirmaExclusaoComponent, ErrorGenericoComponent, SelectComponent, NgxPaginationModule, RouterLink, AsyncPipe, CamelCasePipe, CnpjPipe, UsuarioPermissaoPipe]
})
export class DadosEmpresaFiliaisComponent implements OnInit {

  public idEmpresaLogada: string = localStorage.idEmpresaLogada;

  // MANIPULAÇÃO DE ALERTS
  public alertConfirmacao: boolean = false;
  public alertSucesso: boolean = false;
  public alertLoading: boolean = false;
  public alertError: boolean = false;

  public filiaisEmpresa: any = null;
  public filiaisPorPagina = '6';
  public paginaFilial: number = 1;
  public idEmpresaDeletada: number;

  constructor(private readonly service: DadosEmpresaService) { }

  ngOnInit(): void {
    this.consultaFiliaisEmpresa();
  }

  // Consultando filiais
  consultaFiliaisEmpresa() {
    this.service.getFiliais(this.idEmpresaLogada)
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        if(response.status === 'OK') {
          this.filiaisEmpresa = response.response;
        } else {
          this.filiaisEmpresa = false;
        }
      },
      error: () => {
        this.filiaisEmpresa = false;
      }
    }
    );

  }

  // PASSOS PARA A EXCLUSÃO DA FILIAL
  // PASSO 1 - Confirmação se deseja excluir (alert perguntando)
  confirmaExclusao(idEmpresaDeletada: number) {
    this.idEmpresaDeletada = idEmpresaDeletada;
    this.alertConfirmacao = true;
  }

  // PASSO 2 - Verifica qual botão o usuário clicou, se clicou no confirmar AVANÇA o passo e chama a função de excluir
  fecharAlertConfirmacao(evento: string) {
    // Se clicar no botão de CONFIRMAR ele chama a função pra excluir
    if(evento === 'Confirmar') {
      this.alertConfirmacao = false;
      this.excluirFilial();
    } else { // Se não apenas fecha o alert de confirmação e não faz nada
      this.alertConfirmacao = false;
    }

  }

  // PASSO 3 - Chama a API para dar DELETE na filial, exibindo um loading e a mensagem se der certo a exclusão
  excluirFilial() {

    this.alertLoading = true;

      this.service.deleteFilial(this.idEmpresaDeletada)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          this.alertLoading = false;
          if(response.status === 'OK') {
            this.alertSucesso = true;
            this.consultaFiliaisEmpresa();
          } else {
            this.alertError = true;
          }
        },
        error: (error: any) => {
          this.alertLoading = false;
          this.alertError = true;
          console.error(error);
        }
      });
  }

  zeraPagina() { this.paginaFilial = 0; }

  // Fechar o alerta de sucesso, clicando no botão OK
  fecharAlertSucesso(evento: string) { this.alertSucesso = false; }

  // Fechar o alerta de erro, clicando no botão OK
  fecharAlertError(evento: string) { this.alertError = false; }

}
